/**
 * @generated SignedSource<<e9e7971505a01cdea8ebe1a76e02f4b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type numberField_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly fieldId: string;
  readonly name: string;
  readonly number: number | null;
  readonly " $fragmentType": "numberField_updateWorkItemAllFieldTypesActionRenderer";
};
export type numberField_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: numberField_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"numberField_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "numberField_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ],
  "type": "JiraNumberField"
};

(node as any).hash = "edd3d50f232d5628dc08cba6adc0c6d4";

export default node;
